import Routes from "next-routes";

import { getConfig } from "../../config/app";
import { addFindAndGetUrls } from "./addFindAndGetUrls";
import { MapRoutes } from "./mapRoutes";
import { LOGIN, REQUOTE, CheckoutStatus } from "../modules/checkout/constants";
import { FormVariant } from "@comparaonline/car-dealer-chile";
import { FormVariantURLMapper } from "../modules/carDealer/constants";

const businessSlugs = getConfig("businessUnits.slugs").join("|");

const friendlyURLNames = Object.values(FormVariant)
  .map(variant => FormVariantURLMapper[variant])
  .join("|");

const businessUnitRoute = `/:business(${businessSlugs})`;
const router = addFindAndGetUrls(new Routes()) as Routes;

router
  .add(MapRoutes.QUOTE_FORM, `${businessUnitRoute}/form/:formId/quote`, MapRoutes.QUOTE_FORM)
  .add(
    MapRoutes.QUOTE_LOGIN,
    `${businessUnitRoute}/form/:formId/quote/:formStatus(${LOGIN})`,
    MapRoutes.QUOTE_FORM
  )
  .add(MapRoutes.RENEWAL, `${businessUnitRoute}/renewal/:formId`, MapRoutes.RENEWAL)
  .add(
    MapRoutes.SOAP_CROSS_SELLING,
    `/:business(seguro-automotriz)/soap-cross-selling/:formId`,
    MapRoutes.SOAP_CROSS_SELLING
  )
  .add(
    MapRoutes.RENEWAL_OFFLINE,
    `${businessUnitRoute}/renewal/:formId/:offerId`,
    MapRoutes.RENEWAL
  )
  .add(MapRoutes.TO_FORM, `${businessUnitRoute}/form/new`, MapRoutes.TO_FORM)
  .add(
    MapRoutes.TO_FORM_FROM_OLD_URLS,
    "/:business(seguro-automotriz)/resultado/index/:params*",
    MapRoutes.TO_FORM
  )
  .add(MapRoutes.RESULTS, `${businessUnitRoute}/results/:formId`, MapRoutes.PRODUCTS)
  .add(
    MapRoutes.CHECKOUT_TO_QUOTE,
    `${businessUnitRoute}/checkout/:formId/:formStatus(${REQUOTE})`,
    MapRoutes.CHECKOUT
  )
  .add(MapRoutes.CHECKOUT, `${businessUnitRoute}/checkout/:formId/:offerId`, MapRoutes.CHECKOUT)
  .add(
    MapRoutes.CHECKOUT_SUCCESS,
    `${businessUnitRoute}/checkout/:formId/:offerId/:formStatus(${CheckoutStatus.Success})`,
    MapRoutes.CHECKOUT
  )
  .add(
    MapRoutes.CHECKOUT_FAILURE,
    `${businessUnitRoute}/checkout/:formId/:offerId/:formStatus(${CheckoutStatus.Failure})`,
    MapRoutes.CHECKOUT
  )
  .add(
    MapRoutes.CHECKOUT_PENDING_PAYMENT,
    `${businessUnitRoute}/checkout/:formId/:offerId/:formStatus(${CheckoutStatus.PendingPayment})`,
    MapRoutes.CHECKOUT
  )
  .add(
    MapRoutes.CHECKOUT_LOGIN,
    `${businessUnitRoute}/checkout/:formId/:offerId/:formStatus(${LOGIN})`,
    MapRoutes.CHECKOUT
  )
  .add(
    MapRoutes.CHECKOUT_STEP,
    `${businessUnitRoute}/checkout/:formId/:offerId/:initialStep`,
    MapRoutes.CHECKOUT
  )
  .add(
    MapRoutes.CICL_PAYMENT_FAILURE,
    `${businessUnitRoute}/payment/:formId/:formStatus(${CheckoutStatus.Failure})`,
    MapRoutes.CHECKOUT
  )
  .add(
    MapRoutes.CICL_PAYMENT_SUCCESS,
    `${businessUnitRoute}/payment/:formId/:formStatus(${CheckoutStatus.Success})`,
    MapRoutes.CHECKOUT
  )
  .add(
    MapRoutes.COMPARE,
    `${businessUnitRoute}/results/:formId/compare/:offerIds`,
    MapRoutes.COMPARE
  )
  .add(`${businessUnitRoute}/results/form/:formId`, MapRoutes.PRODUCTS)
  .add(`${businessUnitRoute}/results/form/:formId/quote`, MapRoutes.PRODUCTS)
  .add(MapRoutes.TIP, `${businessUnitRoute}/tip/:tipSlug`, MapRoutes.TIP)
  .add(
    MapRoutes.PRODUCT_DETAIL,
    `${businessUnitRoute}/product/:divisionSlug/:productSlug`,
    MapRoutes.PRODUCT_DETAIL
  )
  .add(MapRoutes.OFFER_DETAIL, `${businessUnitRoute}/offer/:offerId`, MapRoutes.OFFER_DETAIL)
  .add(
    MapRoutes.CAPTURE,
    `${businessUnitRoute}/form/capture/:divisionSlug/:productSlug`,
    MapRoutes.CAPTURE
  )
  .add(
    MapRoutes.CAR_DEALER,
    `/:business(seguro-automotriz)/automotora/:carDealerName/:variant(${friendlyURLNames})?`,
    MapRoutes.CAR_DEALER
  )
  .add(
    "/:business(seguro-automotriz)/automotora/:carDealerName/:status(success)",
    MapRoutes.CAR_DEALER
  )
  .add(MapRoutes.PAYMENT, `/payment`, MapRoutes.PAYMENT)
  .add(MapRoutes.FILTERS, `${businessUnitRoute}/:filter*`, MapRoutes.PRODUCTS);

const { Link, Router } = router;

export { router, Link, Router };
